export interface TabProps {
  text: string;
  onClick: () => void;
  className?: string;
}
